const MySharedAssetsColumn = [
    {
        id: "name",
        label: "Name",
        type: "name",
        // 고정폭 컬럼 합계(176+176+160+140+120)를 뺀 나머지를 이름 컬럼이 차지한다.
        style: { custom: { width: "calc(100% - 772px)", pl: 1.5 } },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "project",
        label: "Project",
        type: "project",
        style: { custom: { width: 176 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "expiresAt",
        label: "Share expiration date",
        type: "expireDate",
        // 포르투갈어 "Data de expiração do compartilhamento"가 136px에서 과도하게 wrap되며
        // 우측 컬럼을 압박한다. 2줄로 안정적으로 떨어지는 폭으로 확대.
        style: { custom: { width: 176 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "downloadsRemaining",
        label: "Number of downloads remaining",
        type: "downloadsRemaining",
        style: { custom: { width: 160 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "shared",
        label: "Share date",
        type: "date",
        style: { custom: { width: 140 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
    {
        id: "shared",
        label: "Sharer",
        type: "user",
        style: { custom: { width: 120 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];

const MySharingAssetsColumn = [
    {
        id: "name",
        label: "Name",
        type: "name",
        style: { custom: { width: "calc(100% - 176px)", pl: 1.5 } },
        disabled: true,
        checked: true,
        sortable: false,
    },
    {
        id: "project",
        label: "Project",
        type: "project",
        style: { custom: { width: 176 } },
        disabled: false,
        checked: true,
        sortable: false,
    },
];
export { MySharedAssetsColumn, MySharingAssetsColumn };
